import React from 'react';
import { Icon } from './Icon.js';
export const IconDrawLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7 17L17 7", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("rect", { x: "17", y: "3", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("rect", { x: "3", y: "17", width: "4", height: "4", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconDrawLine.js.map